"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DiagnosticOverview() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section id="diagnostic-overview" className="bg-background py-24 px-6">
      <div className="mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-12">
        {}
        <div ref={leftRef} data-index={0} className={`flex flex-col justify-start transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-foreground leading-relaxed !text-xl">The Practice Growth Diagnostic is a structured evaluation designed to identify the single constraint limiting your practice's growth. Most practices work harder on the wrong problem, this diagnostic creates clarity before execution begins.</p>
        </div>

        {}
        <div ref={rightRef} data-index={1} className={`flex flex-col justify-start transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <ul className="space-y-4 text-foreground leading-relaxed !text-xl">1) Market positioning and competitive clarity <br />2) Patient acquisition and conversion systems <br />3) Operational efficiency and capacity constraints <br />4) Revenue model and pricing structure <br />5) Leadership clarity and decision-making framework</ul>
        </div>
      </div>
    </section>;
}